import apis from './config';

function generateBasicAuthHeader(username, password) {
    if (username.includes(':')) {
        throw new Error("Username cannot contain a colon (':')");
    }

    const credentials = `${username}:${password}`;
    const encodedCredentials = btoa(credentials);
    return `Basic ${encodedCredentials}`;
}

const output = {
    login: (username, password) => {
        const basicAuth = generateBasicAuthHeader(username, password);

        return apis.user.post('login', null, {
            validateCsrf: true,
            retag: true,
            headers: {
                Authorization: basicAuth,
            },
        });
    },
    logout: () => apis.user.post('logout', null, { validateCsrf: true }),
    // The session survives a password change (the JWT carries no password
    // material), so there is nothing to refresh here.
    changePassword: (currentPassword, newPassword) =>
        apis.user.post(
            'password',
            { currentPassword, newPassword },
            {
                retag: true,
                validateCsrf: true,
            }
        ),
    get: () => apis.user.get('auth'),
    check: () =>
        apis.user
            .get('auth')
            .then(() => {
                return true;
            })
            .catch((error) => {
                if (error.response && [401, 403].includes(error.response.status)) {
                    return false;
                }

                throw error;
            }),
};

export default output;
